var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',[_vm._l((_vm.sources),function([format, formatSrc]){return _c('source',{key:`${formatSrc}_${format}`,attrs:{"srcset":formatSrc,"type":`image/${_vm.getType(format) || format}`}})}),_c('img',_vm._b({attrs:{"alt":_vm.alt,"src":_vm.srcAbs}},'img',_vm.$attrs,false))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }